import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["links"];
import React from 'react';
import classNames from 'classnames/bind';
import IconRound from "../IconRound";
import { defaultPropArray } from "../constants";
import { Facebook, Instagram, Odnoklassniki, Telegram, Vk, Youtube } from "../icons";
import styles from './SocialLinks.css';
var cx = classNames.bind(styles);
var iconByType = {
  fb: /*#__PURE__*/React.createElement(Facebook, {
    size: "md"
  }),
  in: /*#__PURE__*/React.createElement(Instagram, {
    size: "md"
  }),
  ok: /*#__PURE__*/React.createElement(Odnoklassniki, {
    size: "md"
  }),
  vk: /*#__PURE__*/React.createElement(Vk, {
    size: "md"
  }),
  yt: /*#__PURE__*/React.createElement(Youtube, {
    size: "md"
  }),
  tg: /*#__PURE__*/React.createElement(Telegram, {
    size: "md"
  })
};

var SocialLinks = function SocialLinks(_ref) {
  var _ref$links = _ref.links,
      links = _ref$links === void 0 ? defaultPropArray : _ref$links,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("ul", _extends({}, rest, {
    className: cx('SocialLinks')
  }), links.map(function (_ref2) {
    var link = _ref2.link,
        type = _ref2.type;
    return /*#__PURE__*/React.createElement("li", {
      key: type,
      className: cx('Item')
    }, /*#__PURE__*/React.createElement("a", {
      href: link,
      className: cx('Link'),
      target: "_blank",
      rel: "nofollow noopener"
    }, /*#__PURE__*/React.createElement(IconRound, null, iconByType[type])));
  }));
};

export default SocialLinks;